import { createFileRoute } from "@tanstack/react-router";
import Dashboard from "@/pages/Dashboard";

export const Route = createFileRoute("/dashboard")({
  head: () => ({
    meta: [
      { title: "Club Pro | Retail Lemon" },
      {
        name: "description",
        content: "Gestiona tu hoja de ruta, consulta a Sara, el Agente Retail IA y controla el avance de tu comercio en Retail Lemon.",
      },
      { property: "og:title", content: "Club Pro | Retail Lemon" },
      {
        property: "og:description",
        content: "Hoja de ruta, Agente Retail IA y herramientas de gestión para tu comercio.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: Dashboard,
});
